import { render, staticRenderFns } from "./ModalCreatePost.vue?vue&type=template&id=54f7dc14&scoped=true&"
import script from "./ModalCreatePost.vue?vue&type=script&lang=js&"
export * from "./ModalCreatePost.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreatePost.vue?vue&type=style&index=0&id=54f7dc14&lang=scss&scoped=true&"
import style1 from "./ModalCreatePost.vue?vue&type=style&index=1&id=54f7dc14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f7dc14",
  null
  
)

export default component.exports